import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import AuthHomeGDC from './AuthHome.GDC';
import AuthHomeGDG from './AuthHome.GDG';
import AuthHomeEFG from './AuthHome.EFG';

const AuthHome = () => {
  switch (portal) {
    case Portal.Gascaribe:
      return <AuthHomeGDC />;
    case Portal.Gasguajira:
      return <AuthHomeGDG />;
    case Portal.Efigas:
      return <AuthHomeEFG />;
    default:
      return <></>;
  }
};

export default AuthHome;
